module.exports = __webpack_public_path__ + "img/greentable.5d41b0d5.webp";